import React, { useState, useEffect } from 'react';

const Registration = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all")
      .then(response => response.json())
      .then(data => {
        const sorted = data.sort((a, b) => a.name.common.localeCompare(b.name.common));
        setCountries(sorted);
      })
      .catch(error => {
        console.error("Error fetching countries:", error);
      });
  }, []);

  return (
    <section className="bg">
      <div className="container pt-5 pb-5">
        <div className="row pt-5 mt-5">
          <div className="col-md-6 col-lg-6 col-12 form-bg">
            <div className="form-container">
              <h2 className="text-center mb-4 text-white">CARE Alumni Membership Registration Form</h2>
              <form>
                <div className="mb-3">
                  <label htmlFor="alumniName" className="form-label">Alumni Name <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" id="alumniName" placeholder="Alumni Name" required />
                </div>

                <div className="mb-3">
                  <label htmlFor="dob" className="form-label">Date Of Birth <span className="text-danger">*</span></label>
                  <input type="date" className="form-control" id="dob" required />
                </div>

                <div className="mb-3">
                  <label htmlFor="age" className="form-label">Age</label>
                  <input type="number" className="form-control" id="age" placeholder="Age" />
                </div>

                <div className="mb-3">
                  <label className="form-label">Gender</label>
                  {['male', 'female'].map((gender, idx) => (
                    <div className="form-check" key={idx}>
                      <input className="form-check-input" type="radio" name="gender" id={gender} value={gender} />
                      <label className="form-check-label" htmlFor={gender}>{gender.charAt(0).toUpperCase() + gender.slice(1)}</label>
                    </div>
                  ))}
                </div>

                <div className="mb-3">
                  <label htmlFor="nationality" className="form-label">Nationality</label>
                  <input type="text" className="form-control" id="nationality" placeholder="Nationality" />
                </div>

                <div className="mb-3">
                  <label htmlFor="regNo" className="form-label">Medical Council Reg.No (For Doctors Only)</label>
                  <input type="text" className="form-control" id="regNo" placeholder="Medical Council Reg.No (For Doctors Only)" />
                </div>

                <div className="mb-3">
                  <label htmlFor="degree" className="form-label">Name of the Degree & Month/Year of Passing <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" id="degree" placeholder="Name of the Degree & Month/Year of Passing" required />
                </div>

                <div className="mb-3">
                  <label htmlFor="bloodGroup" className="form-label">Blood Group</label>
                  <select className="form-select custom-select" id="bloodGroup">
                    <option disabled selected>Blood Group</option>
                    {['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'].map(bg => (
                      <option key={bg} value={bg}>{bg}</option>
                    ))}
                  </select>
                </div>

                {/* Similar pattern continues for each input field... */}

                <div className="mb-3">
                  <label htmlFor="country" className="form-label">Country</label>
                  <select className="form-select custom-select" id="country">
                    <option disabled selected>{countries.length === 0 ? 'Loading countries...' : 'Select Country'}</option>
                    {countries.map(country => (
                      <option key={country.cca3} value={country.name.common}>{country.name.common}</option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label htmlFor="photoUpload" className="form-label">Upload Recent Passport Size Photo</label>
                  <input type="file" className="form-control" id="photoUpload" accept="image/*" />
                  <small className="form-text text-info text-white">
                    Accepted file types: jpg, png, gif, jpeg. Max. file size: 256 MB.
                  </small>
                </div>

                <div className="mb-3">
                  <label htmlFor="consent" className="form-label">Consent <span className="text-danger">*</span></label>
                  <div className="d-flex gap-2">
                    <input type="checkbox" className="form-check-input" id="consent" required />
                    <label htmlFor="consent" className="form-check-label">I agree to be a member of the CARE Alumni</label>
                  </div>
                </div>

                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-submit px-4 py-2 rounded-pill shadow-sm">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Registration;